export var Client;
(function (Client) {
    Client["Web"] = "web";
    Client["Tizen"] = "tizen";
    Client["Panasonic"] = "panasonic";
    Client["WebOS"] = "webos";
    Client["Vidaa"] = "vidaa";
})(Client || (Client = {}));
